module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ByGT6B/tc-custom/9780547601359.jpg?1700825706665",
      "alt": "This image is the cover for the book Penultimate Truth"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Penultimate Truth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this dystopian novel from the author of "), _c('i', [_vm._v("The Man in the High Castle")]), _vm._v(", humanity is forced to live underground while a great secret hides above them.")])]), _c('p', [_vm._v("In the future, most of humanity lives in massive underground bunkers, producing weapons for the nuclear war they’ve fled. Constantly bombarded by patriotic propaganda, the citizens of these industrial anthills believe they are waiting for the day when the war will be over and they can return aboveground. But when Nick St. James, president of one anthill, makes an unauthorized trip to the surface, what he finds is more shocking than anything he could imagine.")]), _c('b', [_vm._v("“At a time when most 20th-century science fiction writers seem hopelessly dated, Dick gives us a vision of the future that captures the feel of our time.”—"), _c('i', [_vm._v("Wired")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Philip K. Dick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("One of the greatest authors of the 20th century, with a career spanning 3 decades and 36 science fiction novels and 121 short stories. Eleven novels and short stories have been adapted to film; notably: Blade Runner, Total Recall, Minority Report, and A Scanner Darkly. Dick won the Hugo Award in 1963 and was inducted into the SF Hall of Fame in 2005, and in 2007 he was the first science fiction to be published by the Library of America.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (hmhbooks.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0